export const DEFAULT_PAYMENT_EXPIRY = 7;
